/*!

=========================================================
* Now UI Dashboard PRO React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard/Dashboard.jsx";
// #ux-redesign-start: imports demo del template Now UI removidos (Components,
// Forms, Tables, Maps, Charts, CalendarX, Widgets, TimelinePage, RTL, PricingPage).
// Esos archivos quedan huérfanos en disco — los podés eliminar en una pasada
// de limpieza cuando confirmemos que ninguna ruta interna apunte a ellos.
// #ux-redesign-end
import Profile from "views/Users/Profile.jsx";
import LoginPage from "views/Users/LoginPage.jsx";
import HelpLogin from "views/Users/helpLogin.jsx";
import PasswordRecovery from "views/Users/PasswordRecovery";
import RegisterPage from "views/Users/RegisterPage.jsx";
import LockScreenPage from "views/Users/LockScreenPage.jsx";
import Welcome from "views/Pages/Welcome";
import Schedule from "views/Schedule/Schedule";
import DoctorList from "views/Doctors/DoctorList";
//Public
import PhysicianPage from "views/Pages/PhysicianPage";

import Settings from "views/Users/Settings.jsx";
import Inbox from "views/Messages/Inbox";
import AppointmentsView from "views/Appointments/AppointmentsView";
import Notes from "views/Notes/Notes";
import SessionManager from 'views/Users/SessionManager';
import IFrameComponent from 'components/iframetest/IFrameComponent';
import LaboratoryStudies from 'views/Laboratories/LaboratoryStudies';
import LaboratoryDetail from "views/Laboratories/LaboratoryDetail";
import UserDeleteConfirmation from "views/Users/UserDeleteConfirmation";
import UserDeletePreparation from "views/Users/UserDeletePreparation";
import VerificationPage from "views/Users/VerificationPage";
import ProfileInitial from "views/Users/ProfileInitial";

// #ux-redesign-start: Account fusiona /profile + /settings (un solo PageContainer + Tabs)
import Account from "views/Users/Account.jsx";
// #ux-redesign-end

// #ux-redesign-start: DS preview oculto (sólo accesible por URL directa)
import DsPreview from "views/_DsPreview/DsPreview.jsx";
// #ux-redesign-end

let routes = [
  {
    path: "/welcome",
    name: "Welcome",
    icon: "now-ui-icons business_bank",
    component: Welcome,
    layout: "/admin",
    invisible: true,
  },
  {
    _id: 14,
    path: "/dashboard",
    name: "Dashboard",
    icon: "icon-d",
    invisible: false,
    section: "hub", // #ux-redesign
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/initial",
    name: "Initial popup",
    icon: "now-ui-icons business_bank",
    component: ProfileInitial,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/delete-confirmation",
    name: "Delete confirmation",
    icon: "now-ui-icons business_bank",
    component: UserDeleteConfirmation,
    layout: "/admin",
    invisible: true,
  },
  {
    _id: 1,
    path: '/doctors',
    name: 'Doctors',
    icon: 'icon-user-active',
    invisible: false,
    section: 'clinical', // #ux-redesign
    component: DoctorList,
    layout: '/admin',
  },
  {
    _id: 2,
    path: "/frametest/:doctor?",
    name: "iFrame",
    icon: "now-ui-icons business_bank",
    section: 'clinical', // #ux-redesign
    component: IFrameComponent,
    layout: "/admin",
    invisible: false,
  },
  {
    _id: 3,
    path: "/lab-studies",
    name: "Laboratory",
    icon: "icon-microscope",
    invisible: false,
    section: 'clinical', // #ux-redesign
    component: LaboratoryStudies,
    layout: "/admin",
  },
  {
    _id: 29,
    path: "/inbox",
    name: "Inbox",
    icon: "icon-inbox",
    invisible: false,
    section: 'communication', // #ux-redesign
    component: Inbox,
    layout: "/admin",
  },
  {
    path: "/schedule",
    name: "Schedule",
    icon: "now-ui-icons  media-1_album",
    component: Schedule,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/sessions",
    name: "Sessions",
    icon: "now-ui-icons  media-1_album",
    component: SessionManager,
    layout: "/admin",
    invisible: true,
  },
  // #ux-redesign-start: grupos demo del template Now UI removidos.
  // Las rutas reales de auth (/login-page, /register-page, /forgot-password,
  // /lock-screen-page, /verification-page, /delete-preparation) se declaran
  // abajo de forma plana, sin el wrapper "Pages" collapsado.
  {
    path: "/register-page",
    name: "Register Page",
    component: RegisterPage,
    layout: "/auth",
    invisible: true,
  },
  {
    path: "/login-page/:data?/:logflag?",
    name: "Login Page",
    component: LoginPage,
    layout: "/auth",
    invisible: true,
  },
  {
    path: "/login-help",
    name: "Help Page",
    component: HelpLogin,
    layout: "/auth",
    invisible: true,
  },
  {
    path: "/verification-page/:token?",
    name: "Verification Page",
    component: VerificationPage,
    layout: "/auth",
    invisible: true,
  },
  {
    path: "/delete-preparation/:token?",
    name: "Deletion Preparation",
    component: UserDeletePreparation,
    layout: "/auth",
    invisible: true,
  },
  {
    path: '/forgot-password',
    name: 'Password Recovery Page',
    component: PasswordRecovery,
    layout: '/auth',
    invisible: true,
  },
  {
    path: "/lock-screen-page",
    name: "Lock Screen Page",
    component: LockScreenPage,
    layout: "/auth",
    invisible: true,
  },
  // #ux-redesign-end

  // new views
  {
    path: "/appointments",
    name: "Appointments",
    icon: "icon-appointments",
    invisible: true,
    component: AppointmentsView,
    layout: "/admin",
  },
  {
    _id: 29,
    path: "/inbox/reply",
    name: "Inbox",
    icon: "icon-inbox",
    invisible: true,
    component: Inbox,
    layout: "/admin",
  },
  {
    path: "/lab-studies-detail/:reportId?/:review?",
    name: "LaboratoryDetail",
    icon: "icon-microscope",
    invisible: true,
    component: LaboratoryDetail,
    layout: "/admin",
  },
  {
    path: "/waiting-room",
    name: "Waiting Room",
    icon: "icon-waiting-room",
    invisible: true,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/notes",
    name: "Notes",
    icon: "icon-note",
    invisible: true,
    component: Notes,
    layout: "/admin",
  },
  /**
   * For public pages
   */
  {
    key: "physician-page",
    path: "/physician-page",
    name: "Physician Profile",
    icon: "now-ui-icons business_bank",
    invisible: true,
    component: PhysicianPage,
    layout: "/public",
  },
  // #ux-redesign-start: Profile + Settings se fusionan en /admin/account.
  // /account NO aparece en el sidebar: la entrada visible al perfil es la
  // user-card del propio Sidebar (ux-sidebar__user). Los shims /profile y
  // /settings siguen siendo redirects para no romper bookmarks externos ni
  // middleware password_expired → /settings.
  {
    _id: 100,
    path: "/account",
    name: "Account",
    icon: "icon-user-active",
    invisible: true,
    component: Account,
    layout: "/admin",
  },
  {
    _id: 32,
    path: "/profile",
    name: "Profile",
    icon: "icon-profile",
    invisible: true,
    component: Profile,
    layout: "/admin",
  },
  {
    _id: 34,
    path: "/settings",
    name: "User Settings",
    icon: "icon-settings1",
    invisible: true,
    component: Settings,
    layout: "/admin",
  },
  // #ux-redesign-end
  // #ux-redesign-start: DS preview interno (no visible en sidebar)
  {
    _id: 999,
    path: "/_ds-preview",
    name: "DS Preview",
    icon: "now-ui-icons design_palette",
    invisible: true,
    component: DsPreview,
    layout: "/admin",
  },
  // #ux-redesign-end
];

export default routes;
